module.exports = __webpack_public_path__ + "img/bicycle_bell.80e83b9a.jpg";